<template lang="pug">
.box
    header.flex.items-center.justify-between.box__header.no-border
        .header-meta
            h2.subheading Detail Location
        .header-cta

    .box__body
        .box-tabs
            vue-tabs
                v-tab(title="City")
                    LocationCity

                v-tab(title="Province")
                    LocationProvince

                v-tab(title="Region")
                    LocationRegion

                v-tab(title="Village")
                    LocationVillage
</template>

<script>
import {VueTabs, VTab} from 'vue-nav-tabs'
import LocationCity from './../../result/location/area/City.vue'
import LocationProvince from './../../result/location/area/Province.vue'
import LocationRegion from './../../result/location/area/Region.vue'
import LocationVillage from './../../result/location/area/Village.vue'

export default {
    name: 'DetailLocation',
    components: {
        VueTabs,
        VTab,
        LocationCity,
        LocationProvince,
        LocationRegion,
        LocationVillage,
        
    },
}
</script>

<style lang="sass">
</style>
